import React from 'react';

interface RunwayProps {
    angle: number;
    color?: string;
}

const Runway: React.FC<RunwayProps> = ({ angle, color = 'grey' }) => (
    <line x1={500} y1={200} x2={500} y2={800} transform={`rotate(${angle} 500 500)`} strokeWidth={100} stroke={color} />
);

export default Runway;
